import { FC } from 'react';
import { Link } from 'react-router-dom';
import { INavLink } from '../../models';
import { PortalCard } from './portal-card';

interface ILinkPortalCard {
  link: INavLink;
}

export const LinkPortalCard: FC<ILinkPortalCard> = ({ link }) => {
  return (
    <Link to={link.url} style={{ textDecoration: 'none' }}>
      <PortalCard link={link} />
    </Link>
  );
};
